import { ChangeEvent, FC, useContext, useState } from "react";
import DeleteModalComponentProps from "./DeleteModalComponentProps";
import './DeleteModalComponentStyles.scss';
import ModalsContext from "../../ModalsContext";
import ButtonComponent from "../../../../components/button/ButtonComponent";
import ModalsContextType from "../ModalsContextType";

const DeleteModalComponent: FC<DeleteModalComponentProps> = ({ }) => {
    const { closeModalDelete, deleteModal } = useContext(ModalsContext) as ModalsContextType;
    const [confirmed, setConfirmed] = useState(false);

    const [inputConfirmation, setInputConfirmation] = useState('');

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        setInputConfirmation(event.target.value);
    }

    const handleSave = () => {
        if ("CONFIRMAR" == inputConfirmation) {
            deleteModal.onConfirm();
            closeModalDelete();
            setInputConfirmation('');
            setConfirmed(false);
        } else setConfirmed(true);
    }

    const handleCancel = () => {
        closeModalDelete();
        setInputConfirmation('');
        setConfirmed(false);
    }

    if (deleteModal === undefined) return <></>

    return <div className="delete_modal_component">
        <div className="bg_modal" onClick={handleCancel}></div>
        <div className="modal_container">
            <div className="delete_modal_component_header">
                <div>{deleteModal.title}</div>
                <div onClick={handleCancel}>
                    <span className="material-symbols-outlined">close</span>
                </div>

            </div>
            <div className="delete_modal_message">¿Está seguro que desea eliminar este elemento?</div>
            <div className="delete_modal_component_content">{deleteModal.content}</div>
            <input className="delete_modal_component_content_input" onChange={(e) => handleInputChange(e)} value={inputConfirmation} type="text" name="" id="" placeholder="CONFIRMAR" />
            {confirmed && <div className="px-2 pb-2">
                <aside className="error_input">El texto no coincide con la palabra CONFIRMAR</aside>
            </div>}
            <div className="delete_modal_component_footer">
                <ButtonComponent className="me-2" onClick={handleCancel} design="dangerOutline" type="button" text="Cancelar" icon={
                    <span className="material-symbols-outlined">close</span>
                } />
                <ButtonComponent onClick={handleSave} design="danger" type="button" text="Eliminar" icon={
                    <span className="material-symbols-outlined">done</span>
                } />
            </div>

        </div>
    </div>
}

export default DeleteModalComponent;
